import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId"];
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import CreateOrEditHubspotPlaylistModal from './CreateOrEditHubspotPlaylistModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreateHubspotPlaylistButton = _ref => {
  let {
      playlistId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCreateButtonClick = () => setIsModalOpen(true);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, Object.assign({
      onClick: handleCreateButtonClick,
      use: "unstyled"
    }, props, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.hubspotPlaylists.createEditModal.createPlaylist"
      })
    })), isModalOpen && /*#__PURE__*/_jsx(CreateOrEditHubspotPlaylistModal, {
      action: "create",
      onClose: () => setIsModalOpen(false),
      playlistId: playlistId
    })]
  });
};